import React from 'react';

export default function UsersTab({
  view,
  onShowList,
  onShowCreate,
  users,
  loadingUsers,
  userError,
  userForm,
  onUserChange,
  onSubmitUser,
  onResetUserForm,
  companyOptions,
  resolveCompanyName,
  resolveUserEmail,
  roleLabel,
}) {
  return (
    <section className="admin-panel">
      <div className="admin-panel-card wide">
        <div className="admin-panel-tabs">
          <button
            type="button"
            className={`admin-panel-tab ${view === 'list' ? 'active' : ''}`}
            onClick={onShowList}
          >
            Ver usuarios
          </button>
          <button
            type="button"
            className={`admin-panel-tab ${view === 'create' ? 'active' : ''}`}
            onClick={onShowCreate}
          >
            Crear usuario
          </button>
        </div>

        {view === 'list' ? (
          <>
            {userError && <div className="admin-alert error">{userError}</div>}

            {loadingUsers ? (
              <p>Cargando usuarios...</p>
            ) : users.length === 0 ? (
              <p>No hay usuarios registrados.</p>
            ) : (
              <div className="admin-scroll full">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Correo</th>
                      <th>Rol</th>
                      <th>Empresa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(item => {
                      const { label, isFallback } = resolveUserEmail(item);
                      return (
                        <tr key={item.id}>
                          <td>
                            <span
                              className={`admin-table-email${isFallback ? ' is-fallback' : ''}`}
                              title={label}
                            >
                              {label}
                            </span>
                          </td>
                          <td>
                            <span className={`badge badge-role-${item.role || 'none'}`}>
                              {roleLabel(item.role)}
                            </span>
                          </td>
                          <td>{resolveCompanyName(item.company)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="admin-panel-head">
              <div>
                <h2>Crear usuario</h2>
                <p>Invita a nuevos miembros y asigna su rol dentro de Flotte.</p>
              </div>
            </div>

            {userError && <div className="admin-alert error">{userError}</div>}

            <form className="admin-grid-form" onSubmit={onSubmitUser}>
              <label>
                Email
                <input
                  type="email"
                  value={userForm.email}
                  onChange={e => onUserChange('email', e.target.value)}
                  required
                />
              </label>

              <label>
                Contrasena
                <input
                  type="password"
                  value={userForm.password}
                  onChange={e => onUserChange('password', e.target.value)}
                  required
                />
              </label>

              <label>
                Nombre completo
                <input
                  type="text"
                  value={userForm.name}
                  onChange={e => onUserChange('name', e.target.value)}
                />
              </label>

              <label>
                Telefono
                <input
                  type="tel"
                  value={userForm.phoneNumber}
                  onChange={e => onUserChange('phoneNumber', e.target.value)}
                />
              </label>

              <label>
                Rol
                <select
                  value={userForm.role}
                  onChange={e => onUserChange('role', e.target.value)}
                >
                  <option value="admin">Administrador</option>
                  <option value="provider">Proveedor</option>
                  <option value="client">Cliente</option>
                </select>
              </label>

              <label>
                Empresa asociada
                <select
                  value={userForm.companyId}
                  onChange={e => onUserChange('companyId', e.target.value)}
                >
                  <option value="">Sin empresa</option>
                  {companyOptions.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>

              <div className="admin-form-actions">
                <button type="submit" disabled={loadingUsers}>
                  {loadingUsers ? 'Guardando...' : 'Crear usuario'}
                </button>
                <button type="button" className="link" onClick={onResetUserForm}>
                  Limpiar formulario
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </section>
  );
}
